module.exports = __webpack_public_path__ + "703c659e4bf563a05c6338a1727e006c.png";